import { headers } from '../common'

async function getListCompanyProfit(params) {

  const queryParams = new URLSearchParams(params);

  return fetch(`/api/profits/company?${queryParams}`)
    .then(res => {
      return res;
    })
    .catch(errors => {
      return errors;
    })
}

async function getListShopProfit(params) {

  const queryParams = new URLSearchParams(params);

  return fetch(`/api/profits/shop?${queryParams}`)
    .then(res => {
      return res;
    })
    .catch(errors => {
      return errors;
    })
}


async function getListStaffProfit(params) {

  const queryParams = new URLSearchParams(params);

  return fetch(`/api/profits/staff?${queryParams}`)
    .then(res => {
      return res;
    })
    .catch(errors => {
      return errors;
    })
}

export { getListCompanyProfit, getListShopProfit, getListStaffProfit }
